"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitForSelect = void 0;
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const types_1 = require("../types");
function WaitForSelect({ value, onChange }) {
    return (react_1.default.createElement(antd_1.Select, { value: value, onChange: onChange, options: [
            { value: types_1.WaitFor.Appear, label: 'Appear' },
            { value: types_1.WaitFor.Disappear, label: 'Disappear' },
        ] }));
}
exports.WaitForSelect = WaitForSelect;
//# sourceMappingURL=WaitForSelect.js.map